import { render } from "./sick-leave-details-modal.vue?vue&type=template&id=46534a50"
import script from "./sick-leave-details-modal.vue?vue&type=script&lang=js"
export * from "./sick-leave-details-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__